<!--demandProp 需量监测 -->
<template>
  <div class="demands">
    <div class="con">
      <div class="tree-left">
        <elUnitTree @checkFun='treeCheckItem' :dataList='getDemanList'></elUnitTree>
      </div>
      <div class="right-table">
        <span class="tits">
          <div class="tt">统计数值</div>
          <div class="ul">
            <div class="li">
              <div class="l">
                <div class="txt">月最大需量</div>
                <div class="mun">{{getMath(2500)}}</div>
              </div>
              <img src="@/assets/imgs/a.png" alt="">
            </div>
            <div class="li">
              <div class="l">
                <div class="txt">日最大需量</div>
                <div class="mun">{{getMath(865)}}</div>
              </div>
              <img src="@/assets/imgs/a.png" alt="">
            </div>
            <div class="li">
              <div class="l">
                <div class="txt">月平均需量</div>
                <div class="mun">{{getMath(2186)}}</div>
              </div>
              <img src="@/assets/imgs/b.png" alt="">
            </div>
            <div class="li">
              <div class="l">
                <div class="txt">本月总需量</div>
                <div class="mun">{{getMath(3954)}}</div>
              </div>
              <img src="@/assets/imgs/c.png" alt="">
            </div>
            <div class="li">
              <div class="l">
                <div class="txt">本年总需量</div>
                <div class="mun">{{getMath(48569)}}</div>
              </div>
              <img src="@/assets/imgs/d.png" alt="">
            </div>

          </div>
        </span>


        <div class="div-flex div-flex2">
          <span class="tit">日需量变化曲线</span>
          <div class="input-smalls">
            <el-date-picker v-model="day" type="date" placeholder="选择日期"
              :picker-options="pickerOptions"></el-date-picker>
          </div>
          <vchart style="height: 100%;" ref='vchart1'></vchart>
        </div>


        <div class="div-flex div-flex3">
          <span class="tit">月需量变化曲线</span>
          <div class="input-smalls">
            <el-date-picker v-model="month" type="month" placeholder="选择日期"
              :picker-options="pickerOptions"></el-date-picker>
          </div>
          <vchart style="height: 100%;" ref='vchart2'></vchart>

        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  import vchart from '@/components/module/chart/vchart.vue'
  import { findDemandByDay, findDemandByMon } from '../../api/abbNewApi.js'

  export default {
    components: {
      vchart,
      elUnitTree
    },
    props: [],
    data() {
      return {
        monthMaxNeed: '',
        dayMaxNeed: '',
        heights: document.getElementById('app').clientHeight - 520,//屏幕高度 - 导航栏高度
        nowDeviceList: [],
        historyData: {}, //查询出来的历史数据,页码对应内容
        day: new Date(),
        month: new Date(),
        dayOption: {
          "title": {
            "left": "20px",
            top: '20px',
            "textStyle": {
              "fontSize": 16,
              "fontWeight": "normal",
              "color": "#1a1a1a"
            }
          },

          "tooltip": {
            "trigger": "axis",
            "confine": true,
            "axisPointer": {
              "animation": true
            }
          },
          "xAxis": {
            "type": "category",
            "data": ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00',]
          },
          "yAxis": {
            "type": "value",
            "boundaryGap": [
              0,
              "100%"
            ],
            "splitLine": {
              "show": false
            }
          },
          "dataZoom": [
            {
              "type": "inside",
              "start": 0,
              "end": 100
            }
          ],
          "grid": {
            "left": "5%",
            "right": "2%",
            "bottom": "40",
            "containLabel": true
          },
          "legend": {
            "data": [],
            "type": "scroll",
            "bottom": "5px",
            "tooltip": {
              "show": true
            },
            "selected": {}
          },
          "series": [
            {
              "data": [820, 932, 901, 934, 1290, 1330, 1320, 820, 932, 901, 934, 1290, 1330, 1320, 820, 932, 901, 934, 1290, 1330, 1320, 1320, 820, 932,],
              "type": "line",
              "smooth": true
            }
          ]
        },
        monthOption: {
          "title": {
            "left": "20px",
            top: '20px',
            "textStyle": {
              "fontSize": 16,
              "fontWeight": "normal",
              "color": "#1a1a1a"
            }
          },

          "tooltip": {
            "trigger": "axis",
            "confine": true,
            "axisPointer": {
              "animation": true
            }
          },
          "xAxis": {
            "type": "category",
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          },
          "yAxis": {
            "type": "value",
            "boundaryGap": [
              0,
              "100%"
            ],
            "splitLine": {
              "show": false
            }
          },
          "dataZoom": [
            {
              "type": "inside",
              "start": 0,
              "end": 100
            }
          ],
          "grid": {
            "left": "5%",
            "right": "2%",
            "bottom": "40",
            "containLabel": true
          },
          "legend": {
            "data": [],
            "type": "scroll",
            "bottom": "5px",
            "tooltip": {
              "show": true
            },
            "selected": {}
          },
          "series": [
            {
              data: [1820, 1932, 1901, 1934, 1290, 1330, 1320],
              "type": "line",
              "smooth": true
            }
          ]
        },
        dayData: undefined,
        monthData: undefined,
        demandTree: [],
        demandApptypeList: [264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275],
        nowDay: 1,
        // dayTimer:new Date(),
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },


        },
        dayXData: [],
        monXData: [],
        mynum: 1
      }
    },
    created() {
      debugPage = this

    },
    mounted() {
      for (let i = 0; i <= 23; i++) {
        this.dayXData.push(i > 10 ? i + ':00' : "0" + i + ':00')
      }
      for (let i = 1; i <= 31; i++) {
        this.monXData.push(i)
      }
      // 创建一个当前日期的 Date 对象
      const today = new Date();
      // 设置时间为当天的00:00:00
      today.setHours(0, 0, 0, 0);
      // 获取当天的00:00:00的时间戳（单位为毫秒）
      this.day = today;


      const todays = new Date();
      // 设置日期为当月的第一天
      todays.setDate(1);
      todays.setHours(0, 0, 0, 0);
      // 获取当月的第一天的 00:00 分的时间戳（单位为毫秒）
      this.month = todays;

      this.$refs.vchart1.setData(this.dayOption, true)
      this.$refs.vchart2.setData(this.monthOption, true)


    },
    destroyed() { },
    computed: {

      nowVariableList() {
        if (isempty(this.nowDeviceList)) {
          return []
        }

        //当前要显示的变量列表
        var variabelTreeArr = []
        this.nowDeviceList.forEach(device => {
          var variableTree = this.$store.variableStore.getters.getVariableTree(device.no)
          variableTree.forEach(item => {
            item.devicename = device.label
          })
          variabelTreeArr.push(variableTree)
        })

        var tree = []
        variabelTreeArr.forEach(item => {
          tree = tree.concat(item)
        })
        var variableList = []
        for (var i = 0, len = tree.length; i < len; i++) {
          var item = tree[i]
          for (var i1 = 0, len1 = item.next.length; i1 < len1; i1++) {
            var item1 = item.next[i1]
            item1.devicename = item.devicename
            if (this.demandApptypeList.includes(item1.typeNo)) {
              var newItem = copy(item1)
              newItem.name = newItem.name.subByFirstChar(".")
              variableList.push(newItem)
            }
          }
        }
        return variableList
      },
      getDemanList() {
        var data = this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data) ? [] : [deviceList(data)]
      }
    },
    watch: {

      month(nv, ov) {
        this.nowDay = 1

      },

      dayData(nv, ov) {
        this.reloadChart(copy(nv), 'day')
      },
      monthData(nv, ov) {
        this.reloadChart(copy(nv), 'month')
      },


    },
    methods: {
      getMath(index = 10) {
        //生成随机数
        let count = Math.round(Math.random() * index);

        return count;
      },
      treeCheckItem(item) {

        this.mynum += 1
        this.nowDeviceList = item;
        if (item) {
          this.newSearchDay()
          this.newSearchMon()
        }

      },
      loadDemandTree() { },
      reloadChart(data, type) {
        var selected = {}
        var legend = []
        var seriesList = []
        if (isempty(data)) {
          //长度为0，清空图表
          if (type == 'day') {
            this.dayOption.series = seriesList
            this.$refs.vchart1.setData(this.dayOption, true)
          } else {
            this.monthOption.series = seriesList
            this.$refs.vchart2.setData(this.monthOption, true)
          }
          return
        }
        // var timeTextList = this.$historyTools.getTimeTextList()
        var timeTextList = this.dayXData
        if (type == 'day') {
          timeTextList = this.dayXData
        } else {
          timeTextList = this.monXData
        }
        for (var i = 0, len = this.nowVariableList.length; i < len; i++) {
          var item = this.nowVariableList[i]
          var itemData = data[item.fromName]
          if (itemData == undefined) {
            itemData = []
          }
          //同时构造数据列
          selected[item.devicename + "_" + item.name] = i > 0 ? false : true
          legend.push({
            name: item.devicename + "_" + item.name,
            icon: 'roundRect'
          })
          seriesList.push({
            name: item.devicename + "_" + item.name,
            type: 'line',
            smooth: true,
            symbol: 'emptyCircle',
            sampling: 'average',
            symbolSize: 6,
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            data: itemData.map((value, index) => {
              var temp = value
              if (this.$historyTools.isNull(temp)) {
                temp = undefined
              }
              if (type == "day") {
                // return [timeTextList[index], temp]
                return temp
              } else {
                return temp
                // return [index, temp]
              }
            })
          })
          //获取最大值
          var maxValue = this.$historyTools.getMax(itemData, 0)
          seriesList[i].markLine = {
            data: [{
              name: item.name + " 最大需量值",
              yAxis: maxValue,
              label: {
                position: 'middle',
                formatter: item.name + ' 最大需量值:' + maxValue
              },
            }]
          }
        }
        if (type == 'day') {
          this.dayMaxNeed = maxValue;
          this.dayOption.series = seriesList
          this.dayOption.legend.data = legend
          this.dayOption.legend.selected = selected
          this.dayOption.xAxis.data = this.dayXData
          this.$refs.vchart1.setData(this.dayOption, true)
        } else {
          this.monthMaxNeed = maxValue;
          this.monthOption.series = seriesList
          this.monthOption.legend.data = legend
          this.monthOption.legend.selected = selected
          this.monthOption.xAxis.data = this.monXData
          this.$refs.vchart2.setData(this.monthOption, true)
        }
      },
      newSearchDay() {
        console.log(this.nowDeviceList)
        if (isempty(this.nowDeviceList)) {
          // this.$dialogMethod.showMessage('请先选择要查询的设备!')
          this.$message({ showClose: true, message: '请先选择要查询的设备', type: 'warning' });
          return
        }
        if (isempty(this.nowVariableList)) {
          // this.$dialogMethod.showMessage('该设备下没有任何需量变量!')
          this.$message({ showClose: true, message: '该设备下没有任何需量变量', type: 'warning' });
          return
        }
        var str = ""
        this.nowDeviceList.forEach(item => {
          str += item.no + ','
        })

        var d = {
          'dayTime': this.day.getTime(),
          'deviceNos': str.slice(0, -1)
        }
        var dayData = {}
        var arrList = []
        findDemandByDay(d).then(res => {
          if (res.code == 200) {
            res.data.forEach(item => {
              arrList = []
              for (let key in item.dayHistory) {
                arrList.push(item.dayHistory[key])
              }
              dayData[item.deviceName] = arrList
            })
            this.dayData = dayData
          }
        })
      },
      newSearchMon() {
        if (isempty(this.nowDeviceList)) {
          this.$message({ showClose: true, message: '请先选择要查询的设备', type: 'warning' });
          return
        }
        if (isempty(this.nowVariableList)) {
          this.$message({ showClose: true, message: '该设备下没有任何需量变量', type: 'warning' });
          return
        }
        var str = ""
        this.nowDeviceList.forEach(item => {
          str += item.no + ','
        })

        var d = {
          'dayTime': this.month.getTime(),
          'deviceNos': str.slice(0, -1)
        }
        var dayData = {}
        var arrList = []
        findDemandByMon(d).then(res => {
          if (res.code == 200) {
            res.data.forEach(item => {
              arrList = []
              for (let key in item.monHistory) {
                arrList.push(item.monHistory[key])
              }
              dayData[item.deviceName] = arrList
            })
            this.monthData = dayData
          }
        })
      },
      searchMonth() {
        if (isempty(this.nowDeviceList)) {
          this.$message({ showClose: true, message: '请先选择要查询的设备', type: 'warning' });
          return
        }
        console.log("this.nowVariableList", this.nowVariableList);
        if (isempty(this.nowVariableList)) {
          this.$message({ showClose: true, message: '该设备下没有任何需量变量', type: 'warning' });
          return
        }
        //查询指定月份每一天的历史数据
        this.nowDay = this.month.getDate()
        this.$api.historyApi.getMonthLoadDemandHistory(this.month.getTime(), this.nowDay, this.nowVariableList.map(item => item.fromName)
          .join(','), respon => {
            this.monthData = respon
          }, respon => {
            this.$message({ showClose: true, message: '指定日期数据不存在', type: 'warning' });
          })
      },
      searchDay() {
        if (isempty(this.nowDeviceList)) {
          this.$message({ showClose: true, message: '请先选择要查询的设备', type: 'warning' });
          return
        }
        if (isempty(this.nowVariableList)) {
          this.$message({ showClose: true, message: '该设备下没有任何需量变量', type: 'warning' });
          return
        }
        var start = new Date(this.day.getFullYear(), this.day.getMonth(), this.day.getDate()).getTime()
        var end = start + 24 * 60 * 60 * 1000 - 1
        var dayKey = this.day.format("yyyyMMdd")
        this.$api.historyApi.searchVariableHistory(this.nowVariableList.map(item => item.fromName).join(','), start, end,
          respon => {
            var result = {}
            for (var i = 0, len = this.nowVariableList.map(item => item.fromName).length; i < len; i++) {
              var nameKey = this.nowVariableList.map(item => item.fromName)[i]
              var value = respon[nameKey]
              if (value == undefined) {
                //没有这天的数据
                result[nameKey] = []
              } else {
                //有数据
                result[nameKey] = value[dayKey].data
              }
            }
            this.dayData = result
          }, respon => {
            this.$message({ showClose: true, message: '指定日期数据不存在', type: 'warning' });
          })
      },
      checkDate(item) {
        this.nowDay = item.value
        this.searchMonth()
      }
    }
  }
</script>

<style scoped lang="scss">
  .div-flex2 {
    border-bottom: 8px solid #e6eef5;
  }

  /* .div-flex3 {
    margin-top: 20px;
  } */

  .div-flex {
    position: relative;
    background: #fff;
    height: 36vh;

    .tit {
      position: absolute;
      top: 20px;
      left: 17px;
    }

    .input-smalls {
      width: auto;
      z-index: 999;
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }

  .demands {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 8px;
      background: #e6eef5;
      display: flex;

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // 正常
      .patrol {
        p {
          width: 8px;
          height: 8px;
          background-color: #0DAE88;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #0DAE88;
        }
      }

      // 非正常
      .rush {
        p {
          width: 8px;
          height: 8px;
          background-color: #FF1D1D;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #FF1D1D;
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        box-sizing: border-box;
        position: relative;

        .tits {
          display: inline-block;
          width: 100%;
          height: 146px;
          background: #fff;
          box-sizing: border-box;
          padding: 20px;
          font-family: Microsoft YaHei;
          font-size: 16px;
          font-weight: normal;
          margin-bottom: 8px;

          .tt {
            color: #1A1A1A;
            font-family: Microsoft YaHei;
            font-size: 16px;
          }

          .ul {
            display: flex;
            margin-top: 12px;

            .li {
              height: 73px;
              width: calc(20% - 10px);
              display: flex;
              background: #FAFAFA;
              box-sizing: border-box;
              border: 1px solid #EBEBEB;
              margin-left: 12px;
              padding: 12px;
              justify-content: space-between;
              align-items: center;

              img {
                width: 36px;
                height: 36px;
              }

              .txt {
                font-family: Microsoft YaHei;
                font-size: 14px;
                color: #4D4D4D;
                margin-bottom: 8px;
              }

              .mun {
                font-family: Arial;
                font-size: 20px;
                font-weight: bold;
                color: #1A1A1A;
              }
            }

            .li:nth-child(1) {
              margin-left: 0;
            }
          }
        }

        .mycharts {
          display: flex;

          .charts-left {
            width: 35%;
          }

          .charts-right {
            width: 70%;
          }
        }
      }
    }
  }
</style>